/**
 *
 * !!! Утилиты проекта
 */

/**
 * * Получить название дня месяца для показа регулярности правила
 * @param {номер дня месяца} dayNum
 */
export const monthDayName = (dayNum) =>
  dayNum === 31
    ? 'последний день каждого месяца'
    : `каждый ${dayNum}-й день мес.`

export const weekName = (weekDayNum) => {
  const names = [
    'по понедельникам',
    'по вторникам',
    'по средам',
    'каждый четверг',
    'каждую пятницу',
    'по субботам',
    'каждое воскресенье',
  ]
  return names[weekDayNum - 1] // номера дней недели с 1!
}

export function truncateWithEllipses(text, max) {
  return text.substr(0, max - 1) + (text.length > max ? '&hellip;' : '')
}

export const ifNullThenEmptyString = (x) => (x === null ? '' : x)

export const deleteFromStateArray = (arr, name, value) => {
  const i = name
    ? arr.findIndex((x) => x[name] === value)
    : arr.findIndex((x) => x === value)
  return [...arr.slice(0, i), ...arr.slice(i + 1)]
}

export function sortByArrayOfNumbers(dataArr, idPropName, arrayOfNumberToSort) {
  var orderObj = arrayOfNumberToSort.reduce((a, c, i) => {
    a[c] = i
    return a
  }, {})

  const sortedDataArray = dataArr.sort(
    (l, r) => orderObj[l[idPropName]] - orderObj[r[idPropName]]
  )

  return sortedDataArray
}

export function formatMoney(
  amount,
  decimalCount = 2,
  decimal = '.',
  thousands = ' '
) {
  try {
    decimalCount = Math.abs(decimalCount)
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount

    const negativeSign = amount < 0 ? '-' : ''

    let i = parseInt(
      (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
    ).toString()
    let j = i.length > 3 ? i.length % 3 : 0

    return (
      negativeSign +
      (j ? i.substr(0, j) + thousands : '') +
      i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
      (decimalCount
        ? decimal +
          Math.abs(amount - i)
            .toFixed(decimalCount)
            .slice(2)
        : '')
    )
  } catch (e) {}
}

export const changeStateArrayItemByIndex = (arr, changedItem, index) => {
  if (index === -1) return addToStateArray(arr, changedItem)
  return [...arr.slice(0, index), changedItem, ...arr.slice(index + 1)]
}

//заменить или добавить объект в массиве объетов, имеющих указанный ключ
export const changeStateArrayItem = (arr, changedItem, keyName) => {
  const atIndex = keyName
    ? arr.findIndex((x) => x[keyName] === changedItem[keyName])
    : arr.findIndex((x) => x === changedItem)
  if (atIndex === -1) return addToStateArray(arr, changedItem)
  return [...arr.slice(0, atIndex), changedItem, ...arr.slice(atIndex + 1)]
}
export const copyDeep = (original) => JSON.parse(JSON.stringify(original))
export const addToStateArray = (arr, newItem) => [...arr, newItem]

export function TextToLink(text) {
  var finalText = text
    .replace(/&/g, '&')
    .replace(/</g, '<')
    .replace(/>/g, '>')
    .replace(/"/g, '')
  var urlPattern = /(http|ftp|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&:\/~+#-;]*[\w@?^=%&\/~+#-;])?/gi
  var htmlData = finalText.replace(
    urlPattern,
    '<a target="_blank" href="$&">$&</a>'
  )
  return htmlData
}

export function toBool(value) {
  return String(value).toLowerCase() === 'true'
}

export function EnumToString(list, value) {
  if (!list) return ''
  const e = list.find((l) => l.value === value)
  return e ? e.caption : ''
}

export function isEmptyObject(obj) {
  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      return false
    }
  }
  return true
}

export function FormatDateForInput(date) {
  if (date) {
    const dateToFormat = new Date(date)

    const year = dateToFormat.getFullYear()

    let month = ''
    let m = dateToFormat.getMonth() + 1
    if (m < 10) {
      month = '0' + m
    } else {
      month = m
    }
    const d = dateToFormat.getDate()
    let day = ''
    if (d < 10) {
      day = '0' + d
    } else {
      day = d
    }
    let r = year + '-' + month + '-' + day

    if (r === '1-01-01') {
      return undefined
    }
    return r
  }
  return date
}

export function FormatDateTimeForJson(date) {
  if (date) {
    const dateToFormat = new Date(date)

    const year = dateToFormat.getFullYear()

    let month = ''
    let m = dateToFormat.getMonth() + 1
    if (m < 10) {
      month = '0' + m
    } else {
      month = m
    }
    const d = dateToFormat.getDate()
    let day = ''
    if (d < 10) {
      day = '0' + d
    } else {
      day = d
    }
    let r = year + '-' + month + '-' + day

    if (r === '1-01-01') {
      return undefined
    }

    let hours = dateToFormat.getHours()
    let minutes = dateToFormat.getMinutes()
    if (hours > 0 && minutes > 0) {
      r =
        r === ''
          ? r
          : r +
            'T' +
            (hours < 10 ? '0' + hours : hours) +
            ':' +
            (minutes < 10 ? '0' + minutes : minutes)
    }

    return r
  }
  return date
}

export function FormatDateForView(date) {
  if (date) {
    const dateToFormat = new Date(date)
    const year = dateToFormat.getFullYear()
    let month = ''
    let m = dateToFormat.getMonth() + 1
    if (m < 10) {
      month = '0' + m
    } else {
      month = m
    }
    const d = dateToFormat.getDate()
    let day = ''
    if (d < 10) {
      day = '0' + d
    } else {
      day = d
    }

    let r = day + '.' + month + '.' + year

    if (r === '01.01.1') {
      return undefined
    }
    return r
  }
  return date
}

export function formatDateTimeForView(date) {
  if (date) {
    const dateToFormat = new Date(date)
    const year = dateToFormat.getFullYear()
    let month = ''
    let m = dateToFormat.getMonth() + 1
    if (m < 10) {
      month = '0' + m
    } else {
      month = m
    }
    const d = dateToFormat.getDate()
    let day = ''
    if (d < 10) {
      day = '0' + d
    } else {
      day = d
    }

    let r = day + '.' + month + '.' + year

    if (r === '01.01.1') {
      r = ''
    }

    let hours = dateToFormat.getHours()
    let minutes = dateToFormat.getMinutes()
    if (hours > 0 && minutes > 0) {
      r =
        r === ''
          ? r
          : r + '  ' + hours + ':' + (minutes < 10 ? '0' + minutes : minutes)
    }
    return r
  }
  return undefined
}

export function formatTimeForView(date) {
  const dateToFormat = new Date(date)
  if (dateToFormat) {
    let hours = dateToFormat.getHours()
    let minutes = dateToFormat.getMinutes()
    if (hours > 0 && minutes > 0) {
      return hours + ':' + (minutes < 10 ? '0' + minutes : minutes)
    }
  }
  return undefined
}

export function getUrlParameterByName(name, url) {
  if (!url) url = window.location.href
  name = name.replace(/[\[\]]/g, '\\$&')
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}
